(() => {

  _.cloneDeep = function (obj) {
    return obj ? JSON.parse(JSON.stringify(obj)) : false;
  }

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') {
      faviconAlert(false);
    }
  });

})();

var TIME = {
  DATA_REQUEST: 60*1000,
  DATA_SPLASH: 5*1000
};

function faviconAlert(active) {
  var fiDefault = 'favicon.ico';
  var fiActive = 'favicon-active.ico';
  var favicon = document.querySelector('link[rel="icon"]');

  if (favicon) {
    var path = favicon.getAttribute('href');

    if (active && !document.hasFocus()) {
      favicon.setAttribute('href', path.replace(fiDefault, fiActive));
    } else {
      favicon.setAttribute('href', path.replace(fiActive, fiDefault));
    }
  }
}
